module.exports = __webpack_public_path__ + "static/media/tiplike.84af5ed4.png";